import { createAction, props } from '@ngrx/store';

export const __DevSetState = createAction(
    '[__DevSetState] Set state',
    props<{ state: any }>(),
);
